import React, { useEffect, useState } from 'react';
import { collection, query, where, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import EditTest from './CreateTest'; // reuse

export default function EditTestList({ batchId, onBack }) {
  const [tests, setTests]       = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(()=>{
    (async()=>{
      const snap=await getDocs(
        query(collection(db,'tests'),where('batch_id','==',batchId))
      );
      setTests(snap.docs.map(d=>({id:d.id,...d.data()})));
    })();
  },[batchId]);

  return (
    <div className="space-y-4">
      <button onClick={onBack} className="text-blue-600 underline">&larr; Back</button>
      <h3 className="text-xl">Your Tests</h3>
      {selected ? (
        <div>
          <EditTest
            batchId={batchId}
            testId={selected.id}
            topic={selected.topic}
            full_marks={selected.full_marks}
            isEditMode
          />
          <button
            onClick={async()=>{
              // delete test and its results
              await deleteDoc(doc(db,'tests',selected.id));
              const resSnap=await getDocs(
                query(collection(db,'testResults'),where('test_id','==',selected.id))
              );
              await Promise.all(resSnap.docs.map(d=>deleteDoc(doc(db,'testResults',d.id))));
              setSelected(null);
            }}
            className="mt-4 px-4 py-2 bg-red-600 text-white rounded"
          >Delete Test</button>
          <button onClick={()=>setSelected(null)} className="ml-4 text-blue-600 underline">Back to List</button>
        </div>
      ) : (
        <ul className="space-y-2">
          {tests.map(t=>(
            <li key={t.id} className="flex justify-between border-b py-2">
              <span>{t.topic} – Full Marks: {t.full_marks}</span>
              <button onClick={()=>setSelected(t)} className="px-2 py-1 bg-blue-600 text-white rounded">View / Edit</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
